export {
    default as PlainTextCard,
    ITemplatePlainTextCardProps,
} from './dashboard-plain-text-card';
